{
  "version": 1,
  "asset_id": "27085d38-3c79-4bea-b2b5-72314bbdb181",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/27085d38-3c79-4bea-b2b5-72314bbdb181/bypass-weight-loss-graph.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/27085d38-3c79-4bea-b2b5-72314bbdb181/bypass-weight-loss-graph.png",
  "original_filename": "bypass-weight-loss-graph.png",
  "size": 197558,
  "content_type": "image/png",
  "created_at": "2026-07-29T11:40:00Z"
}
